import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';

export const streamsList = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s8,
  marginTop: space.s12,
});

export const streamRow = style({
  display: 'flex',
  alignItems: 'center',
  gap: space.s8,
  width: '100%',
  minHeight: 40,
  padding: `0 ${space.s12}px`,
  borderRadius: borderRadius.r8,
  border: `1px solid ${themeVars.container.border.default}`,
  backgroundColor: 'transparent',
  cursor: 'pointer',
  textAlign: 'left',

  ':hover': {
    backgroundColor: themeVars.controls.background.hover,
  },
});

export const streamName = style([
  {
    color: themeVars.container.foreground.primary,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flexShrink: 0,
    maxWidth: '40%',
  },
  typography.labelMd,
]);

export const chipBadge = style([
  typography.labelSm,
  {
    height: 20,
    padding: `0 ${space.s8}px`,
    gap: space.s4,
  },
]);

export const chipBadgeText = style({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: 96,
});

export const countBadge = style([
  chipBadge,
  {
    fontVariantNumeric: 'tabular-nums',
    flexShrink: 0,
  },
]);

export const noShrinkChipBadge = style([
  chipBadge,
  {
    flexShrink: 0,
  },
]);

export const headerSummary = style([
  {
    marginLeft: 'auto',
    color: themeVars.container.foreground.tertiary,
    fontVariantNumeric: 'tabular-nums',
    whiteSpace: 'nowrap',
  },
  typography.labelMd,
]);

export const rowRight = style({
  display: 'flex',
  alignItems: 'center',
  gap: space.s4,
  marginLeft: 'auto',
  minWidth: 0,
});

export const tooltipTargets = style({
  display: 'flex',
  flexWrap: 'wrap',
  gap: space.s4,
  maxWidth: 260,
});

export const tooltipTargetChipText = style([
  chipBadgeText,
  {
    maxWidth: 220,
  },
]);

export const chevron = style({
  color: themeVars.container.foreground.tertiary,
  flexShrink: 0,
  transitionProperty: 'transform',
  transitionDuration: '0.15s',

  selectors: {
    [`${streamRow}[data-state="open"] &`]: {
      transform: 'rotate(180deg)',
    },
  },
});

export const targetsPopover = style({
  width: 'var(--radix-popover-trigger-width)',
  padding: 0,
  overflow: 'hidden',
  border: `1px solid ${themeVars.container.border.default}`,
});

export const popoverSearch = style({
  padding: `${space.s8}px ${space.s12}px`,
  borderBottom: `1px solid ${themeVars.container.border.default}`,
});

export const popoverHeader = style([
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: space.s8,
    padding: `${space.s8}px ${space.s12}px`,
    color: themeVars.container.foreground.secondary,
  },
  typography.labelSm,
]);

export const targetsList = style({
  display: 'flex',
  flexDirection: 'column',
  maxHeight: 240,
  overflowY: 'auto',
});

export const targetItem = style([
  {
    display: 'flex',
    alignItems: 'center',
    gap: space.s8,
    padding: `${space.s6}px ${space.s12}px`,
    cursor: 'pointer',
    color: themeVars.container.foreground.primary,

    ':hover': {
      backgroundColor: themeVars.controls.background.hover,
    },
  },
  typography.bodySm,
]);

export const targetItemText = style({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const emptySearchResult = style([
  {
    padding: `${space.s8}px ${space.s12}px`,
    color: themeVars.container.foreground.tertiary,
  },
  typography.bodySm,
]);

export const popoverFooter = style([
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: space.s8,
    padding: `${space.s8}px ${space.s12}px`,
    borderTop: `1px solid ${themeVars.container.border.default}`,
    color: themeVars.container.foreground.secondary,
  },
  typography.labelSm,
]);
